import type { SVGProps } from 'react';

const SvgAttributionReporting = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="attribution-reporting">
      <path d="M18.23 30.23a.76.76 0 0 0 .7.51.75.75 0 0 0 .7-.5l7.6-21a.74.74 0 0 0-1-.95l-20.84 8A.74.74 0 0 0 5 17a.75.75 0 0 0 .52.69L15 20.77Zm.73-2.5-2.53-7.36L24.66 12ZM23.59 11l-8.23 8.36L8 16.91Z" />
      <path d="m4.542 30.312 7.483-7.607 1.07 1.052-7.484 7.607zM10.436 30.128l3.436-3.493 1.07 1.052-3.437 3.493zM4.499 24.501l3.436-3.494 1.07 1.052-3.436 3.494z" />
      <path d="M28.93 3.89h-16a1.24 1.24 0 0 1-.93-.43l-1.82-2.08a2.74 2.74 0 0 0-2.09-1h-5A2.75 2.75 0 0 0 .32 3.16v21.32a2.75 2.75 0 0 0 2.75 2.75v-1.5a1.25 1.25 0 0 1-1.25-1.25V3.16a1.25 1.25 0 0 1 1.25-1.25h5a1.22 1.22 0 0 1 .93.44l1.8 2.08a2.77 2.77 0 0 0 2.09 1h16a1.25 1.25 0 0 1 1.25 1.25v17.8a1.25 1.25 0 0 1-1.25 1.25H23v1.5h5.95a2.75 2.75 0 0 0 2.75-2.75V6.64a2.75 2.75 0 0 0-2.77-2.75Z" />
    </g>
  </svg>
);

export default SvgAttributionReporting;
